import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

export const NAMESPACE = 'ERROR_BOUNDARY';

i18next.addResources('es', NAMESPACE, {
  ERROR: 'Error',
  INFO: 'Ha ocurrido un error. Por favor intenta nuevamente más tarde.',
  GO_BACK: 'Volver al inicio',
  MORE_INFO:
    'No te preocupes! El error fue reportado automáticamente y el equipo de Humand va a solucionarlo a la brevedad.',
});

i18next.addResources('en', NAMESPACE, {
  ERROR: 'Error',
  INFO: 'An error has occurred. Please try again later.',
  GO_BACK: 'Back to home',
  MORE_INFO:
    'Do not worry! This error was reported automatically and Humand team will fix it ASAP.',
});

i18next.addResources('pt', NAMESPACE, {
  ERROR: 'Erro',
  INFO: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
  GO_BACK: 'Voltar ao início',
  MORE_INFO:
    'Não te preocupes! O erro foi reportado automaticamente e a equipe Humand irá corrigi-lo o mais rápido possível.',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
